import constants from '../constants';

import mixin from './mixin';
import Skeleton from './components/Skeleton.vue';

import Multiselect from 'vue-multiselect';
import VueDatePicker from '@vuepic/vue-datepicker';

const axios = require('axios');

const defaultApp = {
    mixins: [mixin],
    components: { Skeleton, Multiselect, VueDatePicker },
    data() {
        return {
            dataApi: '',
            dataLimit: 9,
            dataSortKey: '',
            dataSortDirection: '',
            dataWidget: false,
            dataSidebar: false,
            dataOverruleIds: [],
            dataOwnid: null,

            loading: false,
            data: {
                items: [],
                facets: [],
                queryCount: 0,
            },
            page: 0,
            searchText: '',

            constants: constants,
        }
    },
    computed: {
        facetsSet() {
            return this.data && this.data.facets && this.data.facets.length;
        },
        itemsSet() {
            return this.data && this.data.items && this.data.items.length;
        },
        filtersChosen() {
            return (this.facetsSet && this.data.facets.some(facet => facet.values.length)) || this.dataOverruleIds.length || this.searchText;
        },
        filtersActive() {
            return (this.facetsSet && this.data.facets.some(facet => facet.selected)) || this.searchText;
        },
        orderItems() {
            if (!this.dataSortKey && !this.dataSortDirection) return [];
            return [
                {
                    Key: this.dataSortKey,
                    Direction: this.dataSortDirection,
                }
            ]
        },
        queryModel() {
            return {
                Limit: this.dataLimit,
                Offset: this.itemsSet && !this.dataWidget ? this.page * this.dataLimit : 0,
                OrderItems: this.orderItems,
                FilterItems: this.filterItems,
                Text: this.searchText,
            }
        },
    },
    methods: {
        async fetchData() {
            try {
                const response = await axios.post(this.dataApi, this.queryModel);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        async fetchDataBlank() {
            try {
                const response = await axios.post(this.dataApi, {
                    Limit: this.dataLimit,
                    Offset: 0,
                    OrderItems: this.orderItems,
                    FilterItems: [],
                    Text: '',
                });
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        async fetchInitialData() {
            this.page = 0;
            const response = await this.fetchData();
            this.setData(response, true);
            this.updateUrl();
        },
        async loadMore() {
            this.page++;
            const response = await this.fetchData();
            this.setData(response);
            this.updateUrl();
        },
        setData(response, replace = false) {
            if (!response || response.status != 200 || !response.data.items) return;
            if (!this.itemsSet || replace) {
                this.data.items = response.data.items;
            }
            else {
                response.data.items.forEach(item => {
                    this.data.items.push(item);
                })
            }
            this.setFacets(response);
        },
        setFacetValuesFromUrl() {
            if (!this.data.facets) return;
            const urlParams = new URLSearchParams(window.location.search);
            if (this.$el.dataset.topics) {
                urlParams.set(constants.filterTitles.topics, this.$el.dataset.topics);
            }
            let filterParams = urlParams.toString() ? urlParams : null;
            /*console.log(filterParams.toString());*/
            if (filterParams) {
                this.data.facets.forEach(facet => {
                    if (filterParams.has(facet.title)) {
                        let valueArray = filterParams.get(facet.title).split(',');
                        facet.values = valueArray.map(alias => facet.options.find(option => option.valueAlias === alias));
                    }
                });
            }
        },
        reset() {
            this.data.facets.forEach(facet => facet.values = []);
            this.searchText = '';
            this.loading = true;
            this.fetchInitialData();
            this.loading = false;
        },
    },
    created() {
        this.changeSearchText = this.debounce(event => {
            this.fetchInitialData();
        });
    },
    mounted() {
        this.init();

        window.addEventListener('update-url', (event) => {
            if (this.dataSidebar) {
                this.data = {
                    items: [],
                    facets: [],
                    queryCount: 0,
                };
                this.init();
            }
        });
    }
};

export default defaultApp;
